const xml_encode_map = {
  '&': '&amp;',
  '"': '&quot;',
  '<': '&lt;',
  '>': '&gt;',
};
export const encodeXml = (string: string) => {
  return string.replace(/([\&"<>])/g, function (str, item) {
    return xml_encode_map[item];
  });
};
